import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { ConsentAuthorizationStepComponent } from "../../wizard/wizard-steps/consent-authorization-step/consent-authorization-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class ConsentAuthorizationStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = ConsentAuthorizationStepComponent;
  }
}
